import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// note: this is not an error boundary, because the kind of errors
// which are handled here happen outside of react
export const GlobalErrorHandler: FC = () => {
  const history = useHistory();

  useEffect(() => {
    const handleError = ({ error }: ErrorEvent) => {
      if (error instanceof Error && error.name === 'ChunkLoadError') {
        location.reload();
      } else {
        history.push('/error');
      }
    };

    const handlePromiseRejection = ({}: PromiseRejectionEvent) => {
      history.push('/error');
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handlePromiseRejection);
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handlePromiseRejection);
    };
  }, [history]);

  return null;
};
